<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item  label="运维人员">
					<el-input v-model="filters.name" placeholder="请输入运维人员"></el-input>
				</el-form-item>
                <el-form-item  label="电话号码">
					<el-input v-model="filters.phone" placeholder="请输入电话号码"></el-input>
				</el-form-item>
                <el-form-item label="所属公司" >
					<el-select v-model="filters.operationcompanyId"  filterable  placeholder="请选择所属公司">
						<el-option
							v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item  label="系统用户名称">
					<el-input v-model="filters.sysName" placeholder="请输入系统用户名称"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="UserDevopss" highlight-current-row v-loading="listLoading"  style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="运维人员">
			</el-table-column>
            <el-table-column prop="phone" label="员工电话">
			</el-table-column>
            <el-table-column prop="operationcompanyName" label="公司名称">
			</el-table-column>
            <el-table-column prop="sysName" label="系统用户">
			</el-table-column>
            <el-table-column prop="certificate" label="证书有效日期">
			</el-table-column>
            <el-table-column  label="运维证书">
               <template slot-scope="scope">
                    <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.srcList">  </el-image>
                </template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)"  v-if="usertype==0"></table-delete-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--Form界面 角色修改、添加-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formUserDevops" label-width="100px" :rules="formRules" ref="formUserDevops">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="formUserDevops.name" ></el-input>
				</el-form-item>
                <el-form-item label="电话号码" prop="phone">
					<el-input v-model="formUserDevops.phone" ></el-input>
				</el-form-item>
				<el-form-item label="所属公司" prop="operationcompanyId">
					<el-select v-model="formUserDevops.operationcompanyId"  filterable  placeholder="请选择所属公司">
						<el-option
							v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="系统用户" prop="userid">
					<el-select v-model="formUserDevops.userid"  filterable  placeholder="请选择系统用户">
						<el-option
							v-for="item in systemUserList" :label="item.name" :value="item.userId" :key="item.userId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="证书有效期" prop="certificate">
					<el-date-picker v-model="formUserDevops.certificate" align="right" type="date" format="yyyy-MM-dd" 	value-format="yyyy-MM-dd" > </el-date-picker>
				</el-form-item>
                <el-form-item label="证书图片" prop="picture">
					<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file" :on-change="change" :on-remove="remove"
					 accept="image/*"  :file-list="fileListShow"  list-type="picture" multiple :auto-upload="false">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { getUserDevopsList,deleteUserDevopss,updateUserDevops,addUserDevops,getOperationCompanyList,getSystemUserList } from '../../api/api';
	import {formatDate} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { myButton,TableUpdateButton,TableDeleteButton },
		data() {
			return {
				filters: {
					name: '',
                    phone:'',
                    operationcompanyId:'',
                    sysName:''
				},
				UserDevopss: [],
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				type:'新增',

				formVisible: false,//修改界面是否显示
				loading: false,
				formRules: {
					name: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					phone: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					certificate: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					userid: [
						{ required: true, message: '必选', trigger: 'change' }
					],
					operationcompanyId: [
						{ required: true, message: '必选', trigger: 'change' }
					],
					picture: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
				},
				//修改界面数据
				formUserDevops: {
					name: '',
					phone: '',
					certificate: '',
					userid: '',
					operationcompanyId: '',
					picture: ''
				},
				formHeight:0,
                operationcompanyList:[],
                systemUserList:[ ],
				fileList: [],
				fileListShow:[],
				removeFileId:[],
				length:0,
				usertype:sessionStorage.getItem("type"),
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getUserDevopss();
				}else if(type=="add"){
					this.handleAdd();
				}else if(type=="reset"){
					this.reset();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getUserDevopss();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getUserDevopss();
			},
            reset(){
                this.filters={
                    name: '',
                    phone:'',
                    operationcompanyId:'',
                    sysName:''
                };
            },
            getOperationCompanyList(){
                if(this.operationcompanyList.length>0){
                    return;
                }
				getOperationCompanyList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.operationcompanyList = res.data.data;
				});
            },
            getSystemUserList(){
                if(this.systemUserList.length>0){
                    return;
                }
				getSystemUserList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.systemUserList = res.data.data;
				});
            },
			//获取用户列表
			getUserDevopss() {
                let para = Object.assign({}, this.filters);
                para.page= this.page;
                para.pageSize=this.pageSize;

				this.listLoading = true;
				getUserDevopsList(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					 this.total = res.data.total;
					 this.UserDevopss = res.data.data;
                     this.UserDevopss.forEach(element => {
                        var arr=[];
                        var imgarr=element.picture.split(';');
                        for(var j=0;j<imgarr.length;j++){
                            if(imgarr[j]==""){
                                continue;
                            }
                            var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
                            arr.push(url);
                        }
                        element.srcList=arr;
					});
				});
			},
			remove:function(file, fileList){
				if(file.name==undefined){
					var i=0;
					this.fileList.forEach(element => {
						if(element.uid==file.uid){
							this.fileList.splice(i, 1);
							return;
						}
						i++;
					});
				}else{
					this.removeFileId.push(file.name);
				}
			},
			change:function(file, fileList){
				//判断上传文件数量
				this.length=document.querySelector("input[type=file]").files.length;
				if(this.length>0){
					Array.from(document.querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileList.indexOf(file) == -1){
							this.fileList.push(file);
						}
					})
				}
				return false;
			},
			httpRequest(){},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该条记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.loading = true;
					let param = new URLSearchParams()
					param.append('id', row.id)
					deleteUserDevopss(param).then((res) => {
						this.loading = false;
                        if(res.data=="false"||res.data==false){
                            this.$message({
                                message: "操作失败，请重试",
                                type: 'error'
                            })
                        }else{
                            this.$message({ 
								message: '操作成功',
								type: 'success'
							});
                        }
						this.getUserDevopss();
					});
				}).catch(() => {

				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.removeFileId=[];
				this.fileList=[];
                this.getSystemUserList();
				this.formVisible = true;
				if( this.$refs.formUserDevops!=undefined){
               		this.$refs.formUserDevops.resetFields();
				}
				this.type='修改';

				this.fileListShow=[];
				var imgarr=row.picture.split(';');
				for(var j=0;j<imgarr.length;j++){
					if(imgarr[j]==""){
						continue;
					}
					var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
					var obj={
						url:url,
						name:imgarr[j]
					}
					this.fileListShow.push(obj);
				}
				this.formUserDevops = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.fileListShow=[];
				this.removeFileId=[];
				this.fileList=[];
                this.getSystemUserList();
				this.formVisible = true;
				if( this.$refs.formUserDevops!=undefined){
               		this.$refs.formUserDevops.resetFields();
				}
				this.type='新增';
				
				this.formUserDevops = {
					name: '',
					phone: '',
					certificate: '',
					userid: '',
					operationcompanyId: '',
					picture: '11'
				}
			},
			//Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
            },
			//修改
			editSubmit: function () {
				this.$refs.formUserDevops.validate((valid) => {
					if (valid) {
						if(this.fileList.length+this.formUserDevops.srcList.length<=this.removeFileId.length){
							this.$message({
								message: "请上传证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let formData = new FormData();
							var i=0;
							this.fileList.forEach(file=> {
								formData.append("files"+i, file);
								i++;
							});
							formData.append("removeId",this.removeFileId.toString());

							formData.append("id",this.formUserDevops.id);
							formData.append("name",this.formUserDevops.name);
							formData.append("phone",this.formUserDevops.phone);
							formData.append("certificate",this.formUserDevops.certificate);
							formData.append("userid",this.formUserDevops.userid);
							formData.append("operationcompanyId",this.formUserDevops.operationcompanyId);
							formData.append("picture",this.formUserDevops.picture);

							updateUserDevops(formData).then((res) => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.$message({
									message: '操作成功',
									type: 'success'
								});
								this.fileListShow=[];
								this.removeFileId=[];
								this.formVisible = false;
								this.getUserDevopss();
							}).catch(error => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，可能是文件过大",
										type: 'error'
									})
									return;
								}
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.formUserDevops.validate((valid) => {
					if (valid) {
						if(this.fileList.length==0){
							this.$message({
								message: "请上传证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
							var i=0;
							this.fileList.forEach(file=> {
								i++;
								formData.append("files"+i, file);
							});

							formData.append("name",this.formUserDevops.name);
							formData.append("phone",this.formUserDevops.phone);
							formData.append("certificate",this.formUserDevops.certificate);
							formData.append("userid",this.formUserDevops.userid);
							formData.append("operationcompanyId",this.formUserDevops.operationcompanyId);
							this.loading = true;
							addUserDevops(formData).then((res) => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.$message({
									message: '操作成功',
									type: 'success'
								});
								this.fileListShow=[];
								this.removeFileId=[];
								this.formVisible = false;
								this.getUserDevopss();
							}).catch(error => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，可能是文件过大",
										type: 'error'
									})
									return;
								}
							});
						});
					}
				});
			},
			//取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-100;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getUserDevopss();
            this.getOperationCompanyList();
		}
	}

</script>

<style scoped>
	.containerUserDevops{
		display: flex;
	}
	.containerUserDevops .block {
		-ms-flex: 1;
		flex: 1;
		padding: 0 24px;
	}
	.containerUserDevops .title{
		font-weight: bold;
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// UserDevops.vue?f38a718a